import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultConstruction,
  defaultContactInfo,
  defaultCosts,
  defaultDescription,
  useManualAndInternationalAddress,
  useRentPriceTypeCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const propertyOwnerStoreRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    mainFloorSpace: validationRules.mainFloorSpaceRequired,
    separableSpace: validationRules.separableSpace,
    totalFloorSpace: validationRules.totalFloorSpaceOptional,
    price: useRentPriceTypeCondition,
  },
  costs: defaultCosts,
  otherFacilities: {
    frontWindowLength: validationRules.frontWindowLength,
    floorLoad: validationRules.floorLoad,
    totalFloorsNumber: validationRules.totalFloors,
    goodsLiftLoad: validationRules.loadLiftingValue,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
  connections: defaultConnections,
}
